// extracted by mini-css-extract-plugin
module.exports = {"NewCourse":"NewCourse_NewCourse__2ScTR"};